import {
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
  forwardRef,
} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {
  ControlValueAccessor,
  FormControl,
  FormGroup,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {EmIconModule, EmInputModule} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';
import {tap} from 'rxjs/operators';

interface FindReplace {
  find: string;
  replace: string;
}

@Component({
  selector: 'em-find-replace',
  templateUrl: './find-replace.component.html',
  styleUrls: ['./find-replace.component.scss'],
  imports: [
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    EmInputModule,
    EmIconModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmFindReplaceComponent),
      multi: true,
    },
  ],
})
export class EmFindReplaceComponent implements ControlValueAccessor, OnInit {
  private readonly _destroyRef = inject(DestroyRef);

  @Input() parentForm: FormGroup | undefined;
  @Input() set touched(value: boolean | null | undefined) {
    if (value) {
      this.formGroup.markAllAsTouched();
    }
  }

  protected readonly formGroup = new FormGroup({
    find: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    replace: new FormControl('', {nonNullable: true}),
  });

  private _onChangeCallback?: (val: FindReplace) => void;

  ngOnInit(): void {
    this.formGroup.valueChanges
      .pipe(
        tap(() => {
          if (this._onChangeCallback) {
            this._onChangeCallback(this.formGroup.getRawValue());
          }
        }),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe();
  }

  //#region ControlValueAccessor implementation
  writeValue(findReplace: FindReplace): void {
    this.formGroup.patchValue(findReplace);
  }

  registerOnChange(fn: (val: FindReplace) => void): void {
    this._onChangeCallback = fn;
  }

  registerOnTouched(): void {
    // throw new Error('Method not implemented.');
  }
  //#endregion
}
